import { lazy } from "react"

const ActiveAccountRoutes = [
    {
        path: "/active-account/:id",
        component: lazy(() => import("@views/profile"))
    }
]

export default ActiveAccountRoutes